import { ILoadFileRequestParams, loadFileRequest } from '../../file-download';
import { HttpStatusCode, RestClientHttpError } from '../../restClient';
import { LoadStorageFileErrorType } from '../types';
import { loadRemoteEntity } from './loadRemoteEntity';

interface ILoadStorageFileResult {
  blob: Blob | null;
  isError: boolean;
  errorType: LoadStorageFileErrorType | null;
}

export async function loadRemoteFile(
  url: string,
  params: ILoadFileRequestParams = {}
): Promise<ILoadStorageFileResult> {
  try {
    const blob = await loadRemoteEntity(url, params, loadFileRequest);
    return {
      blob,
      isError: false,
      errorType: null,
    };
  } catch (error) {
    const restError = error as RestClientHttpError;
    let errorType = LoadStorageFileErrorType.Unhandled;

    if (restError.statusCode === HttpStatusCode.Unknown) {
      errorType = LoadStorageFileErrorType.BadUrl;
    }

    return {
      blob: null,
      isError: true,
      errorType,
    };
  }
}
